<div class="name-dialog">
  <div class="name-dialog__header">
    <pdq-heading element="h3" class="name-dialog__title">{{ data.title }}</pdq-heading>
    <pdq-button variant="ghost" icon="close" ariaLabel="Close" (onClick)="cancel()"></pdq-button>
  </div>

  <pdq-input
    label="Setup name"
    [placeholder]="data.placeholder ?? ''"
    [invalid]="!!error"
    [(ngModel)]="name"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="error = ''"
    (onEnter)="confirm()"></pdq-input>

  @if (data.help) {
    <p class="name-dialog__help">{{ data.help }}</p>
  }

  @if (error) {
    <p class="name-dialog__error">{{ error }}</p>
  }

  <div class="name-dialog__actions">
    <pdq-button variant="light" label="Cancel" (onClick)="cancel()"></pdq-button>
    <pdq-button variant="primary" [label]="data.confirmText" (onClick)="confirm()"></pdq-button>
  </div>
</div>
